module.exports = __webpack_public_path__ + "img/paint-03.81ef8c49.png";